import styled from "styled-components";

export const Wrapper = styled.div`
  .ranking-list-main {
    margin-top: 10px;
  }
  .rank-section {
    align-items: center;
    border-radius: 10px;
    padding:3px 0px ;
     /* margin-top: 15px; */
    margin-bottom: 10px; 
    border:1px solid lightgrey;
    background: linear-gradient(110deg, #4287a3 60%, #9edef7 60%);
  } 
  .rank-title {
    display: flex;
    justify-content: center;
    font-size: 15px;
    font-weight: 500;
    border: 2px gray;
    padding: 5px;

  }
  .rank-sales{
    display: flex;
    justify-content: center;
    font-size: 15px;
    font-weight: 500;
    border: 2px gray;
    padding: 5px;
  }
  .ranker-image {
    display: flex;
    align-items: center;
    margin-left: 110px;
    color:white;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #fff;
      margin-left: 65px;
      object-fit: cover;
    }
  }
  .ranker-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color:white;
    h5 {
      margin: 0%;
      font-size:15px;
      color:white;
    }
    span {
      font-size: 12px;
      opacity:0.6;
    }
  }

  @media only screen and (max-width: 700px){
    .ranker-image {
    margin-left: 50px;
    img {
      margin-left: 30px;
    }
    }
  @media only screen and (max-width: 470px) {
    .rank-title {
      span {
        font-size: 13px;
        font-weight: 600;
      }
    }

    .ranker-image {
      span {
        font-size: 13px;
        font-weight: 600;
      }
    }
    .ranker-info {
      h5 {
        margin: 0%;
        font-size: 13px;
        font-weight: 600;
      }
      span {
        font-size: 12px;
      }
    }
  }
  @media only screen and (max-width: 500px) {
    .ranker-name {
      h4 {
        font-size: 12px !important;
      }
    }
    .sales-gold {
      font-size: 22px !important;
    }
    .time-button {
      h5 {
        font-size: 16px !important;
        font-weight: 600 !important;
      }
      button{
        width: 100px !important;
      }
    }
    .office-button{
      h5{
        font-size: 16px !important;
        font-weight: 600 !important;
      }
      button{
        width: 100px !important;
      }
    }
  }
  @media only screen and (max-width: 445px) {
    .ranker-image {
      margin-left: 5px;
        span{
          margin: 0px 8px;
        }
      img {
        margin-left: 10px;
        width: 30px;
        height: 30px;
      }
    }
  }
}




`;